import React from 'react';

export const terminationMessages = {
  value: 'Termination',
  list: [
    {
      value: (
        <>
          In the event that any information provided by the user is inaccurate,
          in breach of any laws or contains indecent elements, Glints shall
          instantly abrogate the user’s account and membership without notice
          and reserves the right to take any action as it considers appropriate,
          desirable or necessary, including but not limited to taking legal
          action against such user. Glints reserves the right at any time to
          immediately terminate or suspend any user’s account or access to the
          Site without notice, where Glints is of the opinion that the user has
          breached any of the Terms and Conditions or violated any law or
          regulation, and to take further action as Glints in its sole
          discretion considers appropriate, desirable or necessary, including
          removing any material which it deems abusive, illegal, disruptive or
          inappropriate. Glints shall have the sole and absolute discretion to
          decide whether the user, Job Seeker or Advertiser has breached any of
          the Terms and Conditions, and such decision shall be final. In case
          Glints has not exercised the right under this Clause, it shall not be
          deemed to be a waiver.
        </>
      ),
    },
  ],
};
